import { openBlock as e, createElementBlock as o, renderSlot as s } from "vue";
import { _ as c } from "../../_plugin-vue_export-helper-dad06003.js";
const l = {}, t = { class: "grid grid-cols-3 gap-px md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6" };
function d(r, i) {
  return e(), o("div", t, [
    s(r.$slots, "default")
  ]);
}
const _ = /* @__PURE__ */ c(l, [["render", d]]);
export {
  _ as default
};
